/**
 * BareMetalServer Information Column Configuration
 *
 * Uses shared column factory for base columns and config columns.
 * Includes processor column for server templates.
 */
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import type { TFunction } from 'i18next'
import {
    ServiceDetailRow,
    buildServiceDetailColumns,
} from '@/modules/Service/utils/service-detail'

// ============================================================================
// Column Configuration - Server.VBM / BareMetalServer template
// ============================================================================

export const createBareMetalServerColumns = (
    t: TFunction,
    rows: ServiceDetailRow[] = []
): DataTableColumn<ServiceDetailRow>[] => {
    return buildServiceDetailColumns({
        t,
        rows,
        includeProcessor: true,
        configPresets: ['ip', 'power', 'bandwidth', 'peakBandwidth'],
        customConfigs: [
            // Memory uses capacity * commitment for VBM
            {
                key: 'memory',
                title: 'RAM',
                configName: 'memory',
                width: 100,
                useCapacityCommitment: true,
            },
            // Disk uses capacity * commitment for VBM
            {
                key: 'disk',
                title: 'DISK',
                configName: 'disk',
                width: 100,
                useCapacityCommitment: true,
            },
        ],
    })
}
